export default {
  //Constants
  showInnerPageHeading: true,
  Version: '2.0.3 Development',
  SortIcons: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
  SearchFieldPlaceHolder: "Filter...",
  hydrowareTableSkin: "hydroware-table VueTables__table table table-bordered table-hover",
  hydrowareMsgForNoData: "Nothing to display",
  hydrowareTimePickerFormat: "hh:mm a",
  hydrowareTimePickerPlaceholder: "Pick a time",

  //function below is simply for testing - sometimes I (FG) just need to know if I can get to a function in this file
  testing(msg) {
    if(msg == null)
    alert ("THIS IS A TEST")
    else
    alert("MSG: " + msg)
  },

  //Helper Functions --------------------------------------------------------------------------------------
  /********************************************************************************************************
  *********************************************************************************************************
  ** FG - FOOF - After Cert - First Release (5) - instead of msg and ttl as parms I am now using options **
  **     NOTE: any place in the code that had been calling on this function has been modified            **
  **     ALSO NOTE: I removed the old code because all of the commented out code started to become       **
  **                unwieldy.  That old code can be found in any from the backups from                   **
  **                Version Foof_Latest - 1stRelease_Changes_04.80_StillFurtherAlong_DeleteDialogs       **
  **                and prior.                                                                           **
  *********************************************************************************************************
  *********************************************************************************************************/

  /********************************************************************************************************
  *********************************************************************************************************
  ** WORK Functions below are called upon by the convenience functions
  *********************************************************************************************************
  ********************************************************************************************************/
    mergeOptions(defaultOptions, overrideWithTheseOptions) {
      return $.extend({}, defaultOptions, (overrideWithTheseOptions || {}));
    },
  /********************************************************************************************************
  *********************************************************************************************************
  ** WORK Functions below do the actual work of displaying messages in either a popup or a slide in 
  ** notification and they are called on by helper methods down further in this code.                                                                                       **
  *********************************************************************************************************
  *********************************************************************************************************/
    //A popup that displays a message and a single button
    //This function was here in the code prior to certification but I modified it to use options 
    //instead of separate parms for title, message, etc.  I also added the ability to set a flag 
    //so and HTML string can be passed in.
    displayPopupMessage(aVueComponent,options) {
      //when call to this function is made anonymously "this" is undefined/null so the aVueComponent can be used to get this script
      var context = this ? this : aVueComponent.$hydrowareCommonJS;
      var defaultOptions = {title: "Information", message: "A bit of information for you", useHTML: true, confirmButtonText: 'OK'}
      var optionsToUse = context.mergeOptions(defaultOptions,options)
      //aVueComponent.$msgbox({title: optionsToUse.title, message: optionsToUse.message, confirmButtonText: optionsToUse.confirmButtonText})
      aVueComponent.$msgbox(optionsToUse);
    },

    //FG - FOOF - After Cert - First Release Security
    displayHydrowareRestrictedMessage(aVueComponent,options) {
      var defaultOptions = {title: "SECURITY WARNING", 
      message: 'RESTRICTED RESTRICTED RESTRICTED', 
      type: 'warning', 
      customClass:'hydrowareRestricted'}
      var optionsToUse = $.extend({}, defaultOptions, (options || {})); 
      this.displayPopupMessage(aVueComponent,optionsToUse) 
    },
    displayHydrowareRestrictedMessageIfApplicable(aResponse,aVueComponent,options) {
      if(aVueComponent.$hydrowareSecurityJS.isDataRestricted(aResponse)) {
        loader.stopLoader();
        this.displayHydrowareRestrictedMessage(aVueComponent,options) 
        return true;
      }
    },
    //

    //A popup that displays a confirm dialog (two buttons), I added this code so all of the confirms
    //can go thru the same code
    displayConfirmPopup(aVueComponent,options,okCallback,cancelCallback) {
      //when call to this function is made anonymously "this" is undefined/null so the aVueComponent can be used to get this script
      var context = this ? this : aVueComponent.$hydrowareCommonJS;
      var defaultOptions = {
        title: "Please Confirm",
        message: "Arrrre you sure you want to complete this action ?",
        useHTML: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }
      var optionsToUse = context.mergeOptions(defaultOptions,options)
      var okCallback = okCallback ? okCallback : context.displayPopupOKCallbackNotSpecified.bind(null,aVueComponent);
      var cancelCallback = cancelCallback ? cancelCallback : context.displayPopupActionCancelled.bind(null,aVueComponent);
      return aVueComponent.$confirm(
       optionsToUse.message,
       optionsToUse.title, 
       {
       dangerouslyUseHTMLString: optionsToUse.useHTML,
       confirmButtonText: optionsToUse.confirmButtonText, 
       cancelButtonText: optionsToUse.cancelButtonText,
       type: optionsToUse.type
       }
      )
      .then(
        ok=>okCallback(),
        ng=>cancelCallback()
      )
    },
    //A slide in that displays a message, I added this code so all of the notify(s)
    //can go thru the same code
    displayNotification(objectFromUser,options) {
      var defaultOptions = {title: "Notification", message: 'You have been notified', type: 'success'}
      var optionsToUse = $.extend({}, defaultOptions, (options || {}));
      objectFromUser.$notify({title: optionsToUse.title, message: optionsToUse.message, type: optionsToUse.type})
    },
  /********************************************************************************************************
  *********************************************************************************************************
  ** DEFAULT Functions below display default messages when specific callbacks are not specified at the time 
  ** the methods above (those that actually display messages) are run/are called upon                                                                                 **
  *********************************************************************************************************
  *********************************************************************************************************/
    //Function below is called by default if no "OK" callback is specified
    //NOTE: IF THIS POPS UP THEN IN ALL LIKELYHOOD SOMEONE WROTE BAD CODE
    displayPopupOKCallbackNotSpecified(aVueComponent,options) {
      //when call to this function is made anonymously "this" is undefined/null so the aVueComponent can be used to get this script
      var context = this ? this : aVueComponent.$hydrowareCommonJS;
      var defaultOptions = {title: "No Action", message: "No Action Specified"}
      return context.displayPopupMessage(aVueComponent, context.mergeOptions(defaultOptions,options))
    },
    //Function below is called by default if no "Cancel" callback is specified
    displayPopupActionCancelled(aVueComponent,options) {
      //when call to this function is made anonymously "this" is undefined/null so the aVueComponent can be used to get this script
      var context = this ? this : aVueComponent.$hydrowareCommonJS;
      var defaultOptions = {title: "Cancelled", message: "Action Cancelled."}
      return context.displayPopupMessage(aVueComponent, context.mergeOptions(defaultOptions,options))
    },
    
  /********************************************************************************************************
  *********************************************************************************************************
  ** CONVENIENCE functions AND the default functions that they use when callbacks are not specified appear   
  ** below.
  ** They should be used to display specific types of confirmations and notifies                                                                                         **
  *********************************************************************************************************
  ********************************************************************************************************/
    //DELETE CONFIRMATION - SHOULD BE USED TO DISPLAY A DELETE CONFIRMATION POPUP
    displayConfirmDeletePopup(aVueComponent,options,okCallback,cancelCallback) {
      var context = this ? this : aVueComponent.$hydrowareCommonJS; //when call is made anonymously the aVueComponent can be used to get this script
      var defaultOptions = {title: "Confirm Delete", message: "Are you sure you want to delete ?"}
      var cancelCallback = cancelCallback ? cancelCallback : context.displayPopupNoDelete.bind(null,aVueComponent);
      context.displayConfirmPopup(aVueComponent, context.mergeOptions(defaultOptions,options),okCallback,cancelCallback)
    },
    //DELETE CONFIRMATION - DEFAULT WHEN A CANCEL CALLBACK IS NOT SPECIFIED
    displayPopupNoDelete(aVueComponent,options) {
      var context = this ? this : aVueComponent.$hydrowareCommonJS;
      var defaultOptions = {title: "Delete Cancelled", message: "The delete was cancelled."}
      return context.displayPopupMessage(aVueComponent, context.mergeOptions(defaultOptions,options))
    },
    //UPDATE CONFIRMATION - SHOULD BE USED TO DISPLAY AN UPDATE CONFIRMATION POPUP
    displayConfirmUploadPopup(aVueComponent,options,okCallback,cancelCallback) {
      var context = this ? this : aVueComponent.$hydrowareCommonJS; //when call is made anonymously the aVueComponent can be used to get this script
      var defaultOptions = {title: "Confirm Upload", message: "Are you sure you want to upload ?"}
      var cancelCallback = cancelCallback ? cancelCallback : context.displayPopupNoUpload.bind(null,aVueComponent);
      context.displayConfirmPopup(aVueComponent, context.mergeOptions(defaultOptions,options),okCallback,cancelCallback)
    },
    //UPDATE CONFIRMATION - DEFAULT WHEN CANCEL CALLBACK IS NOT SPECIFIED
    displayPopupNoUpload(aVueComponent,options) {
      var context = this ? this : aVueComponent.$hydrowareCommonJS; //when call is made anonymously the aVueComponent can be used to get this script
      var defaultOptions = {title: "Upload Cancelled", message: "The upload was cancelled."}
      return context.displayPopupMessage(aVueComponent, context.mergeOptions(defaultOptions,options))
    },

    //NOTIFY CONVENIENCE METHODS BELOW SHOULD BE USED TO DISPLAY NOTIFY SLIDE IN MESSAGES
      notifyError(objectFromUser,options) {
        var defaultOptions = {title: "Error", message: 'An error occurred', type: 'error'}
        this.displayNotification(objectFromUser,this.mergeOptions(defaultOptions,options));
      },
      notifyDeleteSuccess(objectFromUser,options) {
        var defaultOptions = {title: "Deleted",message: 'Deleted Successfully'}
        this.displayNotification(objectFromUser,this.mergeOptions(defaultOptions,options));
      },
      notifyAddSuccess(objectFromUser,options) {
        var defaultOptions = {title: "Added",message: 'Added Successfully'}
        this.displayNotification(objectFromUser,this.mergeOptions(defaultOptions,options));
      },
      notifyUpdateSuccess(objectFromUser,options) {
        var defaultOptions = {title: "Updated", message: 'Updated Successfully'}
        this.displayNotification(objectFromUser,this.mergeOptions(defaultOptions,options));
      },
      notifyUploadSuccess(objectFromUser,options) {
        var defaultOptions = {title: "Uploaded", message: 'Uploaded Successfully'}
        this.displayNotification(objectFromUser,this.mergeOptions(defaultOptions,options));
      },
  //FG - FOOF - After Cert - First Release (5) - ABOVE
  //*****************************************************************************************
  //*****************************************************************************************


  handleTooltips(createOrDestroy) {
    var giveItSomeTimeMilliseconds = 600;
    if("create")
      window.addEventListener("resize", function(){setTimeout(tooltip.startTooltip(50),giveItSomeTimeMilliseconds)})
    else
      window.removeEventListener("resize", function(){setTimeout(tooltip.startTooltip(50),giveItSomeTimeMilliseconds)})
    },


  //Data masking for data entry
  maskValue(el, aMask) {
    if ( $(el).is( "input" ) ) {
      $(el).mask(aMask)
    }
    else {
      var inputEls = $(el).find('input');
      if(inputEls) {
        $(inputEls[0]).mask(aMask)
      }
    }
  },


  //Edit Functions
  //  The edit function accepts 
  //    the value to be edited
  //  
  //  The edit functions return an object as follows:
  //    OK: a boolean to indicate if the edit passed (true)
  //        or failed (false)
  //    DETAILS: an object as follows:
  //      MSG: a message returned from the edit function 
  //      other key values pairs different for each function
  //isANumber accepts a value and returns true or false to indicate
  //if that value is a number
  isANumber(val) {
    var rtnVal = {"OK": true, "DETAILS":{"MSG":null}}
    rtnVal.OK=!isNaN(parseFloat(val)) && !isNaN(val - 0)
    if(!rtnVal.OK) {
      rtnVal.DETAILS.MSG="Must be a number";
    } 
    return rtnVal;
  },
  //are there too many decimal positions in the reading value
      //  pass into the edit function: 
      //    value to edit
      //    max number of dec places
      //  find out if the value (val) has no more than numberOfDecPlaces significant digits after
      //      the decimal point
      //  The FORMATTED_VALUE returned will be the value with a decimal point and maxNumberOfDecPlaces digits
  checkNumberOfDecimalPlaces(val,maxNumberOfDecPlaces) {
    //If the value passed in isn't a number then we don't continue to check dec. places
    var rtnVal = this.isANumber(val)
    if(rtnVal.OK==false) {
      rtnVal.DETAILS.FORMATTED_VALUE="";
      return rtnVal;
    }
    var val = val.trim()
    //If we get to this point then the val is a number
    rtnVal = {"OK": true, "DETAILS":{"MSG":null,"FORMATTED_VALUE":val}}

    //keep a hold of "this" as context so its available in things like if stmts
    let context = this
    
    //split val at the dec point
    var beforeAndAfterDecPoint = val.split('.')

    //start to build up the FORMATTED_VALUE that will be returned
    //  we have everthing before the dec. point
    rtnVal.DETAILS.FORMATTED_VALUE = beforeAndAfterDecPoint[0]

    //If there are no digits after the dec point and the max number of dec places is zero
    //then we are done
    if(maxNumberOfDecPlaces < 1 && beforeAndAfterDecPoint.length < 2)
      return rtnVal;

    //If we reach this point then there should be at least one digit after the dec. point
    //so we concatenate the dec. point onto the FORMATTED_VALUE that is returned
    rtnVal.DETAILS.FORMATTED_VALUE += '.'

    //If the value being checked has no dec. point or no digits after the dec. point then we are OK
    //and we simply add the proper number of zeros after the dec. point to the FORMATTED_VALUE
    //that we return
    if(beforeAndAfterDecPoint.length<2) {
      rtnVal.DETAILS.FORMATTED_VALUE += ('0'.repeat(maxNumberOfDecPlaces))
      return rtnVal; //OK - there are no dec places
    }

    //If we reach this point then there are digits after a decimal point
    var afterDecPoint = beforeAndAfterDecPoint[1]

    //If there are exactly the same number of digits after the dec. point as maxNumberOfDecPlaces
    //then we finish creating the FORMATTED_VALUE that will be returned and we are OK
    if(afterDecPoint.length == maxNumberOfDecPlaces) {
      rtnVal.DETAILS.FORMATTED_VALUE += afterDecPoint
      return rtnVal; //OK - exactly the right number of dec. places
    }

    //if there are less than maxNumberOfDecPlaces then I pad the FORMATTED_VALUE that will be
    //returned with zeros and its OK
    if(afterDecPoint.length < maxNumberOfDecPlaces) {
      var numOfZerosNeeded = maxNumberOfDecPlaces - afterDecPoint.length;
      rtnVal.DETAILS.FORMATTED_VALUE += ("" + afterDecPoint + ('0'.repeat(numOfZerosNeeded)))
      return rtnVal;
    }

    //If we reach this point then there are more digits after the decimal point than
    //maxNumberOfDecPlaces so we look to see if there are any non-zero digits after
    //the maxNumberOfDecPlaces 
    
    //if the digits after the dec point are all zeros then add the proper number of zeros
    //    to the FORMATTED_VALUE that is returned and we OK
    if(afterDecPoint == 0) {
      rtnVal.DETAILS.FORMATTED_VALUE += ('0'.repeat(maxNumberOfDecPlaces))
      return rtnVal;
    }
    
    //if we reach this point then the number of digits after the decimal point are not
    //    all zeros 
    //Split the digits after the dec point at the max number of digits
    var digitsUpToMax = afterDecPoint.slice(0,maxNumberOfDecPlaces); 
    //Finish building the FORMATTED_VALUE that will be returned
    rtnVal.DETAILS.FORMATTED_VALUE += digitsUpToMax

    //If all the digits after maxNumberOfDecPlaces are zero then concatenate all the digits
    //  up to the maxNumberOfDecDigit onto the FORMATTED_VALUE that will be returned and we OK
    var digitsAfterMax = parseInt(afterDecPoint.slice(maxNumberOfDecPlaces)); 
    if(digitsAfterMax == 0) {
      return rtnVal;
    }

    //If we reach this point then there are too many significnt digits after the decimal point
    //so this edit fails.  The FORMATTED_VALUE we return will be the original value up to the
    //maxNumberOfDecDigits.
    rtnVal.OK = false
    if(maxNumberOfDecPlaces == 0)
      rtnVal.DETAILS.MSG = "No decimal places allowed"
    else
      rtnVal.DETAILS.MSG = "Only " + maxNumberOfDecPlaces + " decimal places allowed"

    return rtnVal;  
  }
}




// WEBPACK FOOTER //
// ./src/hydrowareCommonJS.js